import { GenericTableNumberFormat } from '../../../../../../../../api/generic-tables/dto';

export const NUMBER_FORMAT_TO_TRANSLATION_KEY: Record<GenericTableNumberFormat, string> = {
    [GenericTableNumberFormat.Raw]: 'inside-fifa.generic-tables.number-format.raw',
    [GenericTableNumberFormat.ShortNumber]: 'inside-fifa.generic-tables.number-format.short-number',
    [GenericTableNumberFormat.USD]: 'inside-fifa.generic-tables.number-format.usd',
    [GenericTableNumberFormat.ShortUSD]: 'inside-fifa.generic-tables.number-format.short-usd',
    [GenericTableNumberFormat.Percentage]: 'inside-fifa.generic-tables.number-format.percentage',
    [GenericTableNumberFormat.Unknown]: 'inside-fifa.generic-tables.number-format.unknown',
};
